/** CurrentUserSection — email + AD group badges for the signed-in user. */

import { Badge } from '@/shared/ui/badge';
import { useAuth } from '../../../contexts/AuthContext';

export default function CurrentUserSection() {
  const { capabilities } = useAuth();
  if (!capabilities) return null;

  return (
    <section className="mb-5 flex flex-col gap-2">
      <h3 className="text-sm font-semibold text-foreground">Current User</h3>
      <div className="mt-3">
        <p className="text-sm text-foreground">{capabilities.email || capabilities.user_id}</p>
      </div>
      {capabilities.groups.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-1">
          {capabilities.groups.map((g) => (
            <Badge key={g} variant="secondary">
              {g}
            </Badge>
          ))}
        </div>
      )}
    </section>
  );
}
